
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/deezer",
      function () {
        return require("private-next-pages/deezer.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/deezer"])
      });
    }
  